import { ComponentProps, useState, useRef } from "react";
import { SearchProfileOptionDataFragment } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { useUpdateEffect } from "@hooks";
import {
  FilterWithFavouriteProps,
  SearchProfileProps
} from "../utils/filters-record-types";
import { ConsultantSearchProfile } from "../search-profile/search-profile";
import { ControllableCollapsibleFavFilter } from "./_base/controllable-collapsible-fav-filter";

export type SearchProfileFilterProps = FilterWithFavouriteProps & SearchProfileProps;

export const SearchProfileFilter = (props: SearchProfileFilterProps) => {
  const isDirty = !!props.value;
  const title = props.label ?? locale.SearchProfiles;
  const selectRef = useRef(null);
  const [expanded, setExpanded] = useState(isDirty);

  useUpdateEffect(() => {
    if (expanded) {
      selectRef.current.focus();
    }
  }, [expanded]);

  const onChange = (value: SearchProfileOptionDataFragment | null) => {
    props.onChange(value);
  };

  const commonProps: ComponentProps<typeof ConsultantSearchProfile> = {
    value: props?.value,
    type: props?.type,
    onChange: onChange,
    selectProps: {
      controlShouldRenderValue: false,
      showBadge: props?.value !== null,
      optionType: "radio",
      isClearable: props?.value !== null,
      onClear: () => props.resetFilter(),
      onOptionEdit: props.onOptionEdit
    }
  };

  if (props.setFavorite) {
    return (
      <ControllableCollapsibleFavFilter
        title={title}
        isDirty={isDirty}
        isClearable={isDirty}
        isExpanded={expanded}
        onClear={props.resetFilter}
        favorite={props.favorite}
        onSetFavorite={props.setFavorite}
        onExpand={() => setExpanded(!expanded)}
      >
        <ConsultantSearchProfile
          {...commonProps}
          selectProps={{
            ...commonProps.selectProps,
            selectRef,
            isClearable: false,
            controlShouldRenderValue: true,
            openMenuOnFocus: true,
            menuPortalTarget: document.body,
            placeholder: locale.SelectValue,
            inputLabel: null,
            showBadge: false,
            menuPlacement: "auto",
            styleProps: {
              menu: { showBorder: true },
              valueContainer: { padding: 0 },
              menuPortal: { zIndex: 9999 }
            }
          }}
        />
      </ControllableCollapsibleFavFilter>
    );
  }

  return (
    <ConsultantSearchProfile
      {...commonProps}
      selectProps={{
        ...commonProps.selectProps,
        styleProps: {
          control: { showBorder: true },
          menu: { showBorder: true }
        }
      }}
    />
  );
};
